import React from 'react';
import {Filter, FilterProps} from 'react-admin';

const ShippingCountryFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <></>
    </Filter>
);

export default ShippingCountryFilter;
